/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const CustomerOfferChapterReview = zod
  .object({
    chapterId: zod.uuid(),
    coefficientStatus: zod.enum(["UNSET", "SET"]),
    sourceStatus: zod.enum(["VALID", "NEEDS_REPAIR"]),
  })
  .describe(
    "Public-safe completion and source repair are independent. No coefficient number or coefficient-missing content error is exposed here.",
  );

export type CustomerOfferChapterReview = zod.input<typeof CustomerOfferChapterReview>;
export type CustomerOfferChapterReviewOutput = zod.output<typeof CustomerOfferChapterReview>;
